import { useState, useEffect, useCallback } from 'react';
import { findMeFavoriteListV1 } from '@/services/platform/api/me-—-favorites/me-—-favorites';
import type { FavoriteListDto } from '@/services/platform/api/model';

export interface UseFindFavoriteListResult {
  data: FavoriteListDto | null;
  isLoading: boolean;
  refetch: () => Promise<void>;
}

/** Finds the favorite list (if any) that already contains an item of the given type/external id. */
export function useFindFavoriteList(
  itemType: string,
  itemExternalId: string | undefined
): UseFindFavoriteListResult {
  const [data, setData] = useState<FavoriteListDto | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!itemExternalId) {
      setData(null);
      return;
    }
    setIsLoading(true);
    try {
      const response = await findMeFavoriteListV1({ itemType, itemExternalId });
      setData(response.status === 200 ? (response.data ?? null) : null);
    } catch {
      // silent
    } finally {
      setIsLoading(false);
    }
  }, [itemType, itemExternalId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, isLoading, refetch };
}
